import React from 'react'

import { SubHeading } from '../../components'
import { images } from '../../constants'

const FindUs = () => (
	<div className='bg wrapper section-padding' id='contact'>
		<div className='wrapper__info'>
			<SubHeading title="Contact" />
			<h1 className='head-text__cormorant' style={{marginBottom: '3rem'}}> Find Us </h1>
			<div className='findus-content'>
				<p className="p__opensans"> Lane Ends Bungalow, Whatcroft Lane, Rudheath, CW9 75G </p>
				<p className="p__cormorant" style={{color: '#dcca87', margin: '2rem 0'}}> Opening Hours </p>
				<p className="p__opensans"> Mon - Fri: 10:00 am - 02:00 am </p>
				<p className="p__opensans"> Sat - Sun 10:00 am - 03:00 am </p>
			</div>
			<button className="custom-button" style={{marginTop: '2rem'}}> Visit Us </button>
		</div>
		<div className='wrapper__img'> <img src={images.findus} alt="find us" /> </div>
	</div>
)

export default FindUs